import { render, staticRenderFns } from "./FinancialPlanningStep4.vue?vue&type=template&id=39b0fbde&scoped=true"
import script from "./FinancialPlanningStep4.vue?vue&type=script&lang=js"
export * from "./FinancialPlanningStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0fbde",
  null
  
)

export default component.exports